import configMap from './config'
import { loadPageConfig, showPage, pageNames } from '@tencent/hymixed-pcapi'

// 加载本项目的配置文件
loadPageConfig(configMap)

export {
    showPage,
    pageNames
}